"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertStatus = void 0;
var AlertStatus;
(function (AlertStatus) {
    AlertStatus["SUCCESS"] = "success";
    AlertStatus["ERROR"] = "error";
    AlertStatus["INFO"] = "info";
    AlertStatus["WARNING"] = "warning";
})(AlertStatus || (exports.AlertStatus = AlertStatus = {}));
